import axios_req from './axios'
import store from './store'
// const req_url = (store.state.env == 'development' ? '/api' : 'http://data-api.vcbeat.cn')
const req_url = store.state.req_url

let getMeta = (data,cb) => axios_req('post','/getMeta', data, cb)// 元数据

let getFooter = (data,cb) => axios_req('post','/getFooter', data, cb)// 页脚
let getBanner = (data,cb) => axios_req('post','/getBanner', data, cb)// 广告

// 首页
let index = (data,cb) => axios_req('post','/index', data, cb)// 首页

// 登录
let login = (data,cb) => axios_req('post','/login', data, cb)// 登录
let logout = (data,cb) => axios_req('post','/logout', data, cb)// 用户登出
let getUserInfo = (data,cb) => axios_req('post','/getUserInfo', data, cb)// 获取用户注册信息
let getMobileCode = (data,cb) => axios_req('post','/getmobilecode', data, cb)// 获取验证码
let setUserInfo = (data,cb) => axios_req('post','/setUserInfo', data, cb)// 用户注册(无附件)
let _setUserInfo = req_url + '/setUserInfo' // 用户注册（有附件）

let joinActivity = (data,cb) => axios_req('post','/joinActivity', data, cb)// 报名
let _joinActivity = req_url + '/joinActivity'// 报名
let updateUserActivity = (data,cb) => axios_req('post','/updateUserActivity', data, cb)// 报名信息更新
let _updateUserActivity = req_url + '/updateUserActivity'// 报名信息更新
let _addPaperInfo = req_url + '/addPaperInfo'// 提交论文
let addPaperInfo = (data,cb) => axios_req('post','/addPaperInfo', data, cb)// 提交论文（无组件方式）
let getPaperInfo = (data,cb) => axios_req('post','/getPaperInfo', data, cb)// 论文详情
let getPaperUserList = (data,cb) => axios_req('post','/getPaperUserList', data, cb) // 获取报名人
let updatePaperInfo = (data,cb) => axios_req('post','/updatePaperInfo', data, cb) // 更新论文
let _updatePaperInfo = req_url + '/updatePaperInfo' // 更新论文

let getOwnerActivity = (data,cb) => axios_req('post','/getOwnerActivity', data, cb) // 获取注册用户自己参与的活动列表

//个人中心
let getPaperList = (data,cb) => axios_req('post','/getPaperList', data, cb)// 论文列表
let getInvoiceList = (data,cb) => axios_req('post','/getInvoiceList', data, cb)// 发票列表
let getCreditList = (data,cb) => axios_req('post','/getCreditList', data, cb)// 学分列表
let getUserActivityList = (data,cb) => axios_req('post','/getUserActivityList', data, cb)// 帮人报人列表
let _applyInvoice = req_url + '/applyInvoice' // 申请发票（有附件）
let _updateInvoice = req_url + '/updateInvoice'// 更新发票（有附件）
let _applyCredit =  req_url + '/applyCredit' // 申请学分（有附件）
let _updateCredit = req_url + '/updateCredit' // 更新学分（有附件）
let updateInvoice = (data,cb) => axios_req('post','/updateInvoice', data, cb) // 更新发票
let updateCredit = (data,cb) => axios_req('post','/updateCredit', data, cb) // 更新学分
let getFavorite = (data,cb) => axios_req('post','/getFavorite', data, cb) // 获取收藏
let delFavorite = (data,cb) => axios_req('post','/delFavorite', data, cb) // 删除收藏
let addFavorite = (data,cb) => axios_req('post','/addFavorite', data, cb) // 添加收藏
let delPaperInfo = (data,cb) => axios_req('post','/delPaperInfo', data, cb) // 删除论文

// 论坛
let getForumHistory = (data,cb) => axios_req('post','/getForum', data, cb) // 历届论坛
let getForumDetail = (data,cb) => axios_req('post','/getSpecial', data, cb) // 论坛详情页
let getForumTogether= (data,cb) => axios_req('post','/getSpecialModule', data, cb) // 论坛聚合页
let getForumAll= (data,cb) => axios_req('post','/getSpecialList', data, cb) // 论坛聚合页
let getClassList = (data,cb) => axios_req('post','/getClassList', data, cb) // 学习班
let getClassDetail = (data,cb) => axios_req('post','/getClassInfo', data, cb) // 学习班详情
let getTeamDetail = (data,cb) => axios_req('post','/getGroupMember', data, cb) // 人物详情
let getTeam = (data,cb) => axios_req('post','/getGroup', data, cb) // 人物
let getForum = (data,cb) => axios_req('post','/getActivityInfo', data, cb) // 论坛宣传页
let getActivity = (data,cb) => axios_req('post','/getActivity', data, cb) // 活动
let getPartner = (data,cb) => axios_req('post','/getPartner', data, cb) // 合作伙伴
let getArticle = (data,cb) => axios_req('post','/getArticle', data, cb) // 文章详情
let getGroupMemberReport = (data,cb) => axios_req('post','/getGroupMemberReport', data, cb) // 采访报道详情

export  {
	getMeta, getFooter, getBanner,
	index,
	login, logout, getUserInfo, getMobileCode, setUserInfo, _setUserInfo,
	joinActivity, _joinActivity, _addPaperInfo,addPaperInfo, getPaperInfo, getPaperUserList, getOwnerActivity, updateUserActivity, _updateUserActivity, updatePaperInfo, _updatePaperInfo,
	getPaperList, getInvoiceList, getCreditList, getUserActivityList, _applyInvoice, _applyCredit,_updateInvoice,updateInvoice,_updateCredit,updateCredit,
	getFavorite, delFavorite, addFavorite, delPaperInfo,
	getForumHistory, getForumDetail, getForumTogether, getForumAll, getClassList, getClassDetail, getTeamDetail, getTeam, getForum, getActivity, getPartner, getArticle, getGroupMemberReport
}
